import React from "react";

const taxLinks = {
  w9: "https://www.irs.gov/pub/irs-pdf/fw9.pdf",
  w8Forms: "https://www.irs.gov/forms-pubs-search?search=w-8",
};

const TaxForms = () => {
  return (
    <div className="tax-forms-container">
      <h2>Tax Forms</h2>
      <h3>Please fill out the applicable tax form in respect of the legal Subscriber and send to ir@kasba.dev.</h3>
      <ul>
        <li><a href={taxLinks.w9} target="_blank" rel="noopener noreferrer">W-9 Form</a></li>
        <li><a href={taxLinks.w8Forms} target="_blank" rel="noopener noreferrer">W-8 Forms (BEN, BEN-E, ECI, EXP, IMY)</a></li>
      </ul>
    </div>
  );
};

export default TaxForms;
